import { Component } from '@angular/core';

@Component({
  selector: 'app-permission-sets-layout',
  templateUrl: './permissionsets-layout.component.html',
})
export class PermissionsetsLayoutComponent {}
